import { requestGetStudentsSanctioned } from "services/events/attendance";

const { useState, useEffect } = require("react");
const { default: useMainContext } = require("utils/context/useMainContext");

const useStudentSanctioned = ({
    goToEventList,
    loadingRequest,
    eventData
}) => {
    const mainContext = useMainContext();
    const [studentSanctioned, setStudentSanctioned] = useState([]);
    useEffect(() => {
        if (!eventData.isLoaded) return;
        fillStudentsSanctioned();
    }, [eventData.isLoaded]);
    async function fillStudentsSanctioned() {
        const data = eventData.value;
		if (!data) {
			goToEventList();
			return;
		}
        loadingRequest.show();
        try {
            const fetchStudentSanctioned =
                await requestGetStudentsSanctioned(data.dateEventId);
            setStudentSanctioned(fetchStudentSanctioned);
        } catch (err) {
            mainContext.setShowDialogUnexpectedError(true);
        } finally {
            loadingRequest.hide();
        }
    }

    return {
        value: studentSanctioned,
        fill: fillStudentsSanctioned,
    }
}

export default useStudentSanctioned